<template>
    <div>
        <transition name="modal">
            <div class="dialog-modal-mask">
                <div class="large-panel" style="min-height: 80vh;height: auto" @click.stop>
                    <div class="dialog-title" v-t="'message.title_edit_map_image_overlay_setting'"></div>
                    <hr class="dialog-hr">
                    <div class="dialog-body-setting">
                        <!-- 画像名 -->
                        <div class="body-map-image-overlay">
                            <el-form label-width="180px">
                                <el-form-item prop="mapImageOverlayName" ref="mapImageOverlayName" style="margin-bottom:30px;">
                                    <div slot="label" style="text-align:left" v-t="'message.item_map_image_overlay_display_name'"></div>
                                    <el-input id="mapImageOverlayName" v-model="mapImageOverlayName.value" type="text" style="width:300px"
                                            @compositionstart.native="compositionDictNameStart()" @compositionend.native="compositionDictNameEnd()"
                                            @input.native="inputDictNameCheck()"/>
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- 画像ファイル -->
                        <div class="body-map-image-overlay">
                            <el-form label-width="180px">
                                <el-form-item prop="layerImage" ref="layerImage" style="margin-bottom:30px;">
                                    <div slot="label" style="text-align:left" v-t="'message.item_map_image_overlay_image'"></div>
                                    <el-button type="primary" @click="$refs.fileInput.click()" v-t="'message.item_map_image_overlay_select_image'"></el-button>
                                    <input ref="fileInput" type="file" accept="image/*" @change="onFileChange" style="display: none;" />
                                     <!-- 画像を選択ボタンの横にファイル名表示 -->
                                    <span v-if="selectedFile" style="margin-left: 10px; color:#333;">
                                        {{ selectedFile.name }}
                                        <span style="font-size:12px; color:#666;">
                                        ({{ (selectedFile.size/1024).toFixed(1) }} KB)
                                        </span>
                                    </span>
                                    <!-- 追加する画像表示 -->
                                    <div v-if="previewUrl" style="margin-top: 10px;">
                                        <img :src="previewUrl" alt="Preview" style="max-width: 300px; margin-top: 10px; border: 1px solid #ccc;" />
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- 右上 緯度経度 -->
                        <div class="body-map-image-overlay">
                            <el-form label-width="180px">
                                <el-form-item prop="topRightLatLngString" ref="topRightLatLng" style="margin-bottom:30px;">
                                    <div slot="label" style="text-align:left">
                                         <span v-t="'message.item_map_image_overlay_top_right'"></span>
                                         <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-html="$t('message.hint_map_overlay_top_right_latlng')"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt=""/>
                                        </el-tooltip>
                                    </div>
                                    <el-input id="topRightLatLng" v-model="topRightLatLngString" type="text" style="width:300px"
                                        placeholder="例: 34.1234, 135.5678"
                                        @compositionstart.native="compositionDictNameStart()"
                                        @compositionend.native="compositionDictNameEnd()"
                                        @input.native="inputDictNameCheck()"
                                    />
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- 左下 緯度経度 -->
                        <div class="body-map-image-overlay">
                            <el-form label-width="180px">
                                <el-form-item prop="underLeftLatLngString" ref="underLeftLatLng" style="margin-bottom:30px;">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_map_image_overlay_under_left'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-html="$t('message.hint_map_overlay_under_left_latlng')"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt=""/>
                                        </el-tooltip>
                                    </div>
                                    <el-input id="underLeftLatLng" v-model="underLeftLatLngString" type="text" style="width:300px"
                                        placeholder="例: 34.1234, 135.5678"
                                        @compositionstart.native="compositionDictNameStart()"
                                        @compositionend.native="compositionDictNameEnd()"
                                        @input.native="inputDictNameCheck()"
                                    />
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- 不透明度 -->
                        <div class="body-map-image-overlay">
                            <el-form label-width="180px">
                                <el-form-item prop="mapImageOverlayInfo.opacity" ref="opacity" style="margin-bottom:30px;">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_map_image_overlay_opacity'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_map_overlay_opacity')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt=""/>
                                    </el-tooltip>
                                </div>
                                <el-slider
                                    v-model="mapImageOverlayInfo.opacity"
                                    :min="0"
                                    :max="1"
                                    :step="0.1"
                                    :format-tooltip="formatOpacityTooltip"
                                    style="width: 300px;"
                                />
                                <!-- Preview ボタン -->
                                <div style="text-align: right; margin-top: 10px;">
                                    <el-button type="primary" @click="handlePreviewClick">Preview</el-button>
                                </div>
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- 重ねる順序 -->
                        <div class="body-map-image-overlay" v-if="false">
                            <el-form label-width="180px">
                                <el-form-item prop="mapImageOverlayInfo.zIndex" ref="zIndex" style="margin-bottom:30px;">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_map_image_overlay_zindex'"></span>
                                </div>
                                <!-- 重ねる順序スライダー -->
                                <el-slider
                                    v-model="mapImageOverlayInfo.zIndex"
                                    :min="1"
                                    :max="10"
                                    :step="1"
                                    style="width: 300px;"
                                />
                                <!-- Preview ボタン -->
                                <div style="text-align: right; margin-top: 10px;">
                                    <el-button type="primary" @click="handlePreviewClick">Preview</el-button>
                                </div>
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- Google Map -->
                        <div id="googleMapWrapper" style="position: relative; width: 100%; height: 400px;">
                            <div id="googleMap" style="position: absolute; top: 0; left: 0; right: 0; bottom: 30px;"></div>
                        </div>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" type="button" @click="resetToOriginalState(); $emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveEdit" v-t="'message.button_save'"></el-button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import commonValidate from '@/components/common-validate.js';
import VueCookie from 'vue-cookie';

export default {
    props: {
        appData: {
            type: Object,
            required: true
        },
        add: {
            type: Boolean,
            default: false
        },
        edit: {
            type: Boolean,
            default: false
        },
        baseMapImageOverlayInfo : {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            mapImageOverlayName: {validationRule: "reqDisplayName", value: "", isComposing: false, error: false},
            originalMapImageOverlayInfo: [],
            actionSave: false,
            underLeftLatLngString: '35.6800,139.7660',
            topRightLatLngString: '35.6825,139.7685',
            mapImageOverlayInfo: {
                underLeftLat: '35.6800',
                underLeftLng: '139.7660',
                topRightLat: '35.6825',
                topRightLng: '139.7685',
                opacity: 1.0,
                zIndex: '',
                objectSize: 0,
                objectKey: '',
            },
            // プレビュー用（URL か base64）
            previewUrl: '',
            // 選択された実ファイル（親へ emit）
            selectedFile: null,
            // 既存のプレビューURLを解放するため保持
            _objectUrlForRevoke: null,
            overlayInstance: null,
            fileSize: 0,
        };
    },
    computed: {
        existDictNameError: function() {
            return this.mapImageOverlayName.error;
        },
        disableSave: function() {
            return this.existDictNameError || this.actionSave;
        },
    },
    created: function() {
        if (this.add) {
            this.mapImageOverlayName.value = "";
            this.mapImageOverlayInfo = {
                underLeftLat: '35.6800',
                underLeftLng: '139.7660',
                topRightLat: '35.6825',
                topRightLng: '139.7685',
                opacity: 1.0,
                zIndex: 1,
                objectKey: '',
                objectSize: 0,
            };
            this.inputDictNameCheck();
            this.originalMapImageOverlayInfo = JSON.parse(JSON.stringify(this.mapImageOverlayInfo));
            this.previewUrl = ''; // 新規はプレビューなし
        } else {
            this.mapImageOverlayName.value = this.baseMapImageOverlayInfo.name;
            this.mapImageOverlayInfo = JSON.parse(JSON.stringify(this.baseMapImageOverlayInfo));
            this.originalMapImageOverlayInfo = JSON.parse(JSON.stringify(this.baseMapImageOverlayInfo));
        }
        this.topRightLatLngString = this.mapImageOverlayInfo.topRightLat + ',' + this.mapImageOverlayInfo.topRightLng;
        this.underLeftLatLngString = this.mapImageOverlayInfo.underLeftLat + ',' + this.mapImageOverlayInfo.underLeftLng;
    },
    mounted: function() {
        const self = this;

        self.loadGoogleMapsScript().then(() => {
            const center = {
            lat: parseFloat(this.mapImageOverlayInfo.underLeftLat ?? 35.6812),
            lng: parseFloat(this.mapImageOverlayInfo.underLeftLng ?? 139.7671)
            };

            this.map = new google.maps.Map(document.getElementById("googleMap"), {
                center,
                zoom: 14,
            });

            const input = {
                id: self.mapImageOverlayInfo.id,
            };

            if (self.edit) {
                server.post('/getmapimageoverlayurl', input)
                .then((res) => {
                    if (res.data.status === constants.STATUS_SUCCESS && res.data.urlList[0]) {
                        self.previewUrl = res.data.urlList[0];
                        self.initGoogleMap();
                    }
                    })
                .catch((error) => {
                    commonUtil.putExceptionErrorMessage(this, "GetMapImageOverlayURL", error);
                });
            } else if (self.add) {
                self.initGoogleMap();
            }
        });
    },
    watch: {
        underLeftLatLngString(val) {
            const parts = val.split(',').map(p => p.trim());
            if (parts.length === 2) {
                this.mapImageOverlayInfo.underLeftLat = parts[0];
                this.mapImageOverlayInfo.underLeftLng = parts[1];
            }
        },
        topRightLatLngString(val) {
            const parts = val.split(',').map(p => p.trim());
            if (parts.length === 2) {
                this.mapImageOverlayInfo.topRightLat = parts[0];
                this.mapImageOverlayInfo.topRightLng = parts[1];
            }
        },
    },
    methods: {
        loadGoogleMapsScript() {
            return new Promise((resolve, reject) => {
                if (typeof google !== 'undefined' && google.maps) {
                    resolve();
                    return;
                }
                const existingScript = document.getElementById('google-maps-script');
                if (existingScript) {
                    existingScript.addEventListener('load', resolve);
                    return;
                }

                const script = document.createElement('script');
                script.id = 'google-maps-script';
                script.src =
                    "https://maps.googleapis.com/maps/api/js" +
                    "?key=" + commonUtil.getGoogleMapApiKey() +
                    "&language=" + commonUtil.getBrowserLanguage(VueCookie.get("aldioweb-lang")) +
                    "&region=" + this.appData.countryCodeAlpha2;

                script.async = true;
                script.defer = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        initGoogleMap() {
            const lat1 = parseFloat(this.mapImageOverlayInfo.underLeftLat ?? 35.6812);
            const lng1 = parseFloat(this.mapImageOverlayInfo.underLeftLng ?? 139.7671);
            const lat2 = parseFloat(this.mapImageOverlayInfo.topRightLat ?? 35.6812);
            const lng2 = parseFloat(this.mapImageOverlayInfo.topRightLng ?? 139.7671);

            const centerLatLng = {
                lat: (lat1 + lat2) / 2,
                lng: (lng1 + lng2) / 2,
            };

            const map = new google.maps.Map(document.getElementById("googleMap"), {
                zoom: 14,
                center: centerLatLng,
            });

            // GroundOverlay 表示（プレビューURLがある時のみ）
            if (this.previewUrl &&
                this.mapImageOverlayInfo.underLeftLat &&
                this.mapImageOverlayInfo.underLeftLng &&
                this.mapImageOverlayInfo.topRightLat &&
                this.mapImageOverlayInfo.topRightLng) {

                const bounds = new google.maps.LatLngBounds(
                    { lat: lat1, lng: lng1 },
                    { lat: lat2, lng: lng2 }
                );

                const opacity = parseFloat(this.mapImageOverlayInfo.opacity ?? "1.0");
                const overlay = new google.maps.GroundOverlay(
                    this.previewUrl,
                    bounds,
                    { opacity: opacity, }
                );
                overlay.setMap(map);
                this.overlayInstance = overlay;
            }
            this.map = map;
        },
        handlePreviewClick() {
            if (!this.previewUrl) {
                commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_map_image_overlay_image_file_required"));
                return;
            }
            if (!this.map) return;
            if (!this.validateLatLng()) return;

            // 既存の GroundOverlay を削除
            if (this.overlayInstance) {
                this.overlayInstance.setMap(null);
                this.overlayInstance = null;
            }

            const lat1 = parseFloat(this.mapImageOverlayInfo.underLeftLat);
            const lng1 = parseFloat(this.mapImageOverlayInfo.underLeftLng);
            const lat2 = parseFloat(this.mapImageOverlayInfo.topRightLat);
            const lng2 = parseFloat(this.mapImageOverlayInfo.topRightLng);
            const opacity = parseFloat(this.mapImageOverlayInfo.opacity ?? "1.0");


            // 中心を再設定
            const centerLatLng = {
                lat: (lat1 + lat2) / 2,
                lng: (lng1 + lng2) / 2,
            };
            this.map.setCenter(centerLatLng);

            const bounds = new google.maps.LatLngBounds(
                { lat: lat1, lng: lng1 },
                { lat: lat2, lng: lng2 }
            );

            // 地図の表示範囲を変更
            this.map.fitBounds(bounds);

            const overlay = new google.maps.GroundOverlay(
                this.previewUrl,
                bounds,
                { opacity: opacity }
            );
            overlay.setMap(this.map);
            this.overlayInstance = overlay;
        },
        inputDictNameCheck() {
            if (this.mapImageOverlayName.isComposing) {
                // inputting with IME
                return;
            }
            const validateResult = commonValidate.validateItem(this.$i18n, this.mapImageOverlayName.validationRule, this.mapImageOverlayName.value);
            if (validateResult.valid) {
                if (this.originalMapImageOverlayInfo.name !== this.mapImageOverlayName.value) {
                    this.$emit('validateMapImageOverlayNameDuplicated', this.mapImageOverlayName.value, this.updateNameState);
                } else {
                    this.updateNameState(true, null);
                }
            } else {
                this.updateNameState(false, validateResult.message);
            }
        },
        updateNameState(valid, message) {
            if (valid) {
                this.mapImageOverlayName.error = false;
                this.$refs.mapImageOverlayName.clearValidate();
            } else {
                this.mapImageOverlayName.error = true;
                this.$refs.mapImageOverlayName.validateState = "error";
                this.$refs.mapImageOverlayName.validateMessage = message;
            }
        },
        compositionDictNameStart() {
            this.mapImageOverlayName.isComposing = true;
        },
        compositionDictNameEnd() {
            this.mapImageOverlayName.isComposing = false;
            this.inputDictNameCheck();
        },
        saveEdit() {
            this.actionSave = true;

            if (this.add && !this.selectedFile) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_image_file_required"));
                this.actionSave = false;
                return;
            }
            if (!this.validateLatLng()) {
                this.actionSave = false;
                return;
            }

            const currentParams = {
                name: this.mapImageOverlayName.value,
                objectKey: this.mapImageOverlayInfo.objectKey,
                opacity: this.mapImageOverlayInfo.opacity,
                zIndex: this.mapImageOverlayInfo.zIndex,
                underLeftLat: this.mapImageOverlayInfo.underLeftLat,
                underLeftLng: this.mapImageOverlayInfo.underLeftLng,
                topRightLat: this.mapImageOverlayInfo.topRightLat,
                topRightLng: this.mapImageOverlayInfo.topRightLng,
                objectSize: this.fileSize,
                file: this.selectedFile || null,
            };
            if (this.edit) currentParams.id = this.baseMapImageOverlayInfo.id;

            // 変更なし
            if (this.edit && !this.selectedFile && this.isNoChange(currentParams, this.originalMapImageOverlayInfo)) {
                this.actionSave = false;
                this.$emit('nochange');
                return;
            }

            this.$emit('save', currentParams, this.baseMapImageOverlayInfo);
        },
        formatOpacityTooltip(value) {
            return `${Math.round(value * 100)}%`;
        },
        resetToOriginalState() {
            // 入力値リセット
            this.mapImageOverlayName.value = this.originalMapImageOverlayInfo.name || '';
            this.mapImageOverlayInfo = JSON.parse(JSON.stringify(this.originalMapImageOverlayInfo));
            this.fileSize = this.originalMapImageOverlayInfo.objectSize || 0;

            // 緯度経度テキスト更新
            this.topRightLatLngString = this.mapImageOverlayInfo.topRightLat + ',' + this.mapImageOverlayInfo.topRightLng;
            this.underLeftLatLngString = this.mapImageOverlayInfo.underLeftLat + ',' + this.mapImageOverlayInfo.underLeftLng;

            // ファイル/プレビューを元に戻す（編集時は既存URLを再取得）
            this.selectedFile = null;
            if (this._objectUrlForRevoke) {
                URL.revokeObjectURL(this._objectUrlForRevoke);
                this._objectUrlForRevoke = null;
            }
            if (this.edit) {
                // 既存URLの再取得
                server.post('/getmapimageoverlayurl', { id: this.mapImageOverlayInfo.id })
                    .then((res) => {
                        if (res.data.status === 0 && res.data.urlList[0]) {
                            this.previewUrl = res.data.urlList[0];
                            this.handlePreviewClick();
                        }
                    })
                    .catch((error) => {
                       commonUtil.putExceptionErrorMessage(this, "GetMapImageOverlayURL", error);
                    });
            } else {
                this.previewUrl = '';
                if (this.overlayInstance) {
                    this.overlayInstance.setMap(null);
                    this.overlayInstance = null;
                }
            }
        },
        validateLatLng() {
            const lat1 = parseFloat(this.mapImageOverlayInfo.underLeftLat);
            const lng1 = parseFloat(this.mapImageOverlayInfo.underLeftLng);
            const lat2 = parseFloat(this.mapImageOverlayInfo.topRightLat);
            const lng2 = parseFloat(this.mapImageOverlayInfo.topRightLng);

            if (isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_invalid_latlng"));
                return false;
            }
            if (lat2 <= lat1) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_top_right_lat_must_be_greater"));
                return false;
            }
            if (lng2 <= lng1) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_map_image_overlay_top_right_lng_must_be_greater"));
                return false;
            }
            return true;
        },
        async onFileChange(event) {
            const self = this;
            const file = event.target.files && event.target.files[0];
            if (!file) return;

            try {
                const res = await server.post('/getmapimageoverlaystorageusage', {});
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                    const maxOverlayCount = res.data.maxMapImageOverlayStorageUsageCount;
                    const usedOverlayCount = res.data.mapImageOverlayStorageUsageCount;
                    const maxOverlaySizeBytes = res.data.maxSingleMapImageOverlaySizeBytes;
                    const totalOverlayCapacityMB = (maxOverlayCount / (1024 * 1024)).toFixed(1);
                    const maxOverlayFileSizeMB = (maxOverlaySizeBytes / (1024 * 1024)).toFixed(1);

                    if (file.size >= maxOverlaySizeBytes) {
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_map_image_overlay_file_too_large").replace("{maxOverlayFileSizeMB}", maxOverlayFileSizeMB));
                        event.target.value = "";
                        return;
                    }
                    if ((usedOverlayCount + file.size) >= maxOverlayCount) {
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_map_image_overlay_storage_exceeds_max_capacity").replace("{maxSizeMB}", totalOverlayCapacityMB));
                        event.target.value = "";
                        return;
                    }
                    // OK: 選択ファイルを保持し、プレビューURLを作る
                    self.fileSize = file.size;
                    self.selectedFile = file;

                    // 既存 ObjectURL があれば解放
                    if (self._objectUrlForRevoke) {
                        URL.revokeObjectURL(self._objectUrlForRevoke);
                        self._objectUrlForRevoke = null;
                    }
                    // プレビューURL（ObjectURL）に切り替え
                    self.previewUrl = URL.createObjectURL(file);
                    self._objectUrlForRevoke = self.previewUrl;

                    // マップ再プレビュー
                    self.handlePreviewClick();
                    break;
                    default:
                    commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "getmapimageoverlaystorageusage").replace("{code}", res.data.status));
                    break;
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(self, "GetMapImageOverlayStorageUsage", error);
            }
        },
        floatEq(a, b, eps = 1e-9) {
            const x = parseFloat(a), y = parseFloat(b);
            if (Number.isNaN(x) || Number.isNaN(y)) {
                return String(a).trim() === String(b).trim();
            }
            return Math.abs(x - y) < eps;
        },
        isNoChange(current, original) {
            const sameName  = String(current.name || '').trim() === String(original.name || '').trim();
            const sameOp    = this.floatEq(current.opacity, original.opacity);
            const sameZ     = this.floatEq(current.zIndex ?? 0, original.zIndex ?? 0);
            const sameUlLat = this.floatEq(current.underLeftLat, original.underLeftLat);
            const sameUlLng = this.floatEq(current.underLeftLng, original.underLeftLng);
            const sameTrLat = this.floatEq(current.topRightLat, original.topRightLat);
            const sameTrLng = this.floatEq(current.topRightLng, original.topRightLng);

            return sameName && sameOp && sameZ && sameUlLat && sameUlLng && sameTrLat && sameTrLng;
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-body-setting {
    height: calc(85vh - 180px);
    font-size: 14px;
    overflow: auto;
    padding: 20px;
}
.body-map-image-overlay {
    padding-left: 20px;
    font-size: 14px;
}
.zindex-input-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
.preview-button {
    margin-left: auto;
}
</style>
